<template>
  <div class="profile">
    <div class="profile-box">
      <div class="title">福州中移信息科技有限公司</div>
      <div class="profile-text"><span style="opacity: 0">空空</span>福州中移信息科技有限公司（以下简称：公司）成立于2020年，注册资金100万元，公司位于福州软件园。主要从事通信服务产品，如：三大运营商话费、流量、固话、宽带、号卡等充值服务。 未来，我们将在新技术的加持下，持续进行平台技术升级，增强平台能力，加强市场拓展，扩大品类，创造更有利于产业发展的模式，打造一个智能化、安全、高效的行业联盟平台，更好的为企业和消费者提供互联网电子充值服务。
      </div>
      <div class="profile-text"><span style="opacity: 0">空空</span>
      </div>
      <div class="profile-text"><span style="opacity: 0">空空</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IMG: this.img_host,
    }
  },
  // 页面创建前
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background:#f7f7f7');
  },
  methods: {}
}

</script>
<style scoped>
.profile {
  display: flex;
  justify-content: center;
}

.profile .profile-box {
  width: 1200px;
  background: #fff;
  min-height: 80vh;
  padding: 30px 100px;
  box-sizing: border-box;
  margin-top: 10px;
}

.profile .title {
  font-size: 18px;
  color: #111;
  font-weight: 600;
  text-align: center;
}

.profile .profile-text {
  font-size: 16px;
  color: #666;
  margin-top: 20px;
  line-height: 1.8;
}

</style>



// WEBPACK FOOTER //
// src/components/profile.vue